module.exports = __webpack_public_path__ + "img/austin-pool.10116061.jpg";